<template>
    <div :id="id" class=menu-page>

        <InternalMenu :links="post.children"></InternalMenu>

        <h1>{{ post.title.rendered }}</h1>

    </div>
</template>
<script>
import InternalMenu from '../components/InternalMenu.vue';

export default {
    name : 'MenuPage',
    props : {
        id    : String,
        post  : Object,
    },
    components : {
        InternalMenu,
    },
}
</script>